import styled from "styled-components";
const StyledPage = styled.div`
    &.image,
    &.image * {
        box-sizing: border-box;
    }
    &.image {
        background: linear-gradient(to left, rgba(0, 0, 0, 0.81), rgba(0, 0, 0, 0.81));
        height: 209px;
        position: relative;
        width: 100%;
        flex-shrink: 0;
    }
    .gant-2-1 {
        width: 282px;
        height: auto;
        position: absolute;
        left: 50%;
        translate: -50% -50%;
        top: 50%;
        object-fit: cover;
    }
`;
export default function HeroSection({ retailBrandData, loading }) {
    const storeData = {
        logo: retailBrandData?.mainLogoURL?.replaceAll(" ", "%20") || "",
        image: retailBrandData?.randomBackgroundImage?.replaceAll(" ", "%20") || ""
    };
    return (
        <StyledPage className="image">
            {!loading && (
                <>
                    <div
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundImage: `url(${storeData?.image})`,
                            backgroundSize: "cover",
                            backgroundRepeat: "no-repeat",
                            zIndex: -1
                        }}
                    />
                    <img className="gant-2-1" src={storeData?.logo} alt="gant-2-10.png" />
                </>
            )}
        </StyledPage>
    );
}
